<template>
    <div class="w-full h-full fixed bg-white top-0 left-0 z-50 flex justify-center items-center" data-qa="link-error">
        <div class="flex flex-col gap-7 mx-auto max-w-[938px] pb-14 md:pb-36">
            <SadBrowser class="w-[120px] h-[120px] mx-auto" />
            <h1 class="text-center text-xl" v-if="$store.getters.isCuratedLink || $store.getters.isAddingSub" data-qa="link-error-title">Uh oh! Looks like there is an issue with this link!</h1>
            <h1 class="text-center text-xl" v-else-if="$store.getters.isSelfUpgrading" data-qa="link-error-title">Uh oh! There was an issue upgrading!</h1>
            <h1 class="text-center text-xl" v-else-if="$store.getters.linkError.code === 'LinkNotFound'" data-qa="link-error-title">Uh oh! This link is invalid</h1>
            <h1 class="text-center text-xl" v-else data-qa="link-error-title">We're experiencing temporary issues</h1>

            <div v-if="$store.getters.isPartnerLink">
                <p class="text-center text-lg" data-qa="link-error-text">We couldn't retrieve pricing based on the link provided. Please contact your partner for more information.</p>
            </div>
            <div v-else-if="$store.getters.isPurchaseLink || ($store.getters.isPurchaseLink && $store.getters.isAddingSub)">
                <p class="text-center text-lg" data-qa="link-error-text">We couldn't retrieve pricing based on the link provided. Please contact your sales rep for more information.</p>
            </div>
            <div v-else-if="$store.getters.linkError.code === 'LinkNotFound'">
                <p class="text-center text-lg" data-qa="link-error-text">
                    The link you are trying to access was not found.
                </p>
            </div>
            <div v-else-if="$store.getters.isSelfUpgrading" class="flex justify-center flex-col gap-[inherit]">
                <p class="text-center text-lg" data-qa="link-error-text">Please try again. If the error continues please contact support for help.</p>
                <Link class="mx-auto" href="{{ supportNumber }}" data-qa="link-error-cta">{{ supportNumberDisplay }}</Link>
            </div>
            <div v-else class="flex justify-center flex-col gap-[inherit]">
                <p class="text-center text-lg" data-qa="link-error-text">Please contact support for help.</p>
                <Link class="mx-auto" href="{{ supportNumber }}" data-qa="link-error-cta">{{ supportNumberDisplay }}</Link>
            </div>
            <p class="text-2xs text-center" v-if="$store.getters.linkError?.eventId">Error code: {{ $store.getters.linkError?.eventId }}</p>
        </div>
    </div>
</template>

<script>
import SadBrowser from '@/../svg/Icon_Sad-Browser.svg?component';
import Link from '@/Components/Link.vue';
import { SUPPORT_PHONE_NUMBER} from '@/Util/constants.js';

export default {
    components: {
        SadBrowser,
        Link,
    },
    props: {
    },
    data() {
        return {
        }
    },
    mounted() {
        this.$store.commit('setInitialLoading', false);
    },
    methods: {
        toKebab(string) {
            return string.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();
        }
    },
    computed: {
        supportNumber() {
            return `tel:${SUPPORT_PHONE_NUMBER}`;
        },
        supportNumberDisplay() {
            return SUPPORT_PHONE_NUMBER;
        },
    }
};
</script>

<style lang="scss" scoped>
</style>
